export default "__VITE_ASSET__aaa747c4__"